export default "__VITE_ASSET__C860qaaL__"